import { useParams } from "react-router-dom";
import "./HPDeviceActivityLogsPage.scss";
import ActivityLogsPage from "../../../components/ActivityLogsPage/ActivityLogsPage";
import { GetCalendarDataForDeviceLogsInHP, GetUserActivityLogsForDeviceHp } from "../../../utils/apiCalls/logs";

const HPDeviceActivityLogsPage = () => {
  // Keying on the route param forces a full remount when navigating between
  // different devices' logs, so filters/pagination/date state never leak across ids.
  const { deviceName } = useParams();
  return (
    <ActivityLogsPage
      key={deviceName}
      idParam="deviceName"
      fetchLogs={GetUserActivityLogsForDeviceHp}
      fetchCalendar={GetCalendarDataForDeviceLogsInHP}
      backRoute="/patient-logs"
      defaultFromTab="devices"
    />
  );
};

export default HPDeviceActivityLogsPage;
